import { render, staticRenderFns } from "./ProfileReferencesEditor.vue?vue&type=template&id=177b857f&scoped=true"
import script from "./ProfileReferencesEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileReferencesEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileReferencesEditor.vue?vue&type=style&index=0&id=177b857f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b857f",
  null
  
)

export default component.exports